"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const number_1 = require("../../type-checking/number");
class PercentFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, number_1.isNullableNumberValue)(fieldValue);
        };
        this.getEmptyValue = () => null;
    }
}
exports.PercentFieldValueGetter = PercentFieldValueGetter;
